import { ROUTES } from "@/app/routes";
import { StockListPage } from "@/components/common/StockListPage";
import { useProvisionStocks } from "@/features/provision-stocks/hooks/useProvisionStocks";

export default function ProvisionStocksPage() {
  const { stocks, isLoading, error, refresh } = useProvisionStocks();

  return (
    <StockListPage
      title="Stock provisionnel"
      subtitle="Ce que vous avez acheté et pas encore transformé"
      basePath={ROUTES.provisionStocks}
      stocks={stocks}
      isLoading={isLoading}
      error={error}
      onRetry={() => refresh()}
      emptyHint="Un stock de matières premières doit être créé avant de pouvoir approvisionner."
      kind="Matières premières"
    />
  );
}
